import {createAction} from '@reduxjs/toolkit';
import {DynamicRatesSchema} from '~/root/api/v1/assets/grow';
import {withPayload} from '~/shared/utils/for-redux';

export const dynamicRateRoutine = (type => ({
    aborted: createAction(`${type}/ABORTED`),
    trigger: createAction(`${type}/TRIGGER`),
    get TRIGGER() {
        return this.trigger.type;
    },
    success: createAction(`${type}/SUCCESS`, withPayload<DynamicRatesSchema>),
    get SUCCESS() {
        return this.success.type;
    },
    failure: createAction(`${type}/FAILURE`, withPayload<unknown>),
    get FAILURE() {
        return this.failure.type;
    },
}))('DYNAMIC_RATE' as const);
